import type React from 'react'

interface ErrorMessageProps {
  message: string
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  if (!message) return null

  return (
    <div className="w-full px-4 py-3 mb-4 text-sm border border-solid rounded-lg text-error-700 bg-error-50 border-error-200">
      {message}
    </div>
  )
}
